/* Table of Contents */
/* ------------------------------------------------- */
/* Removes "* " from Titles in the front end */
/* Home Page Sound */
/* Sticky JS */
/* PREORDER / BACKORDER AND INVENTORY CODE */

/* ------------------------------------------------- */

// Removes "* " from Titles in the front end

let card_titles = document.querySelectorAll(".card__heading, .product__title, .cart-item__name, .cart-notification-product__name");
for (let i = 0; i < card_titles.length; i++) {
  let updated_card = card_titles[i].innerHTML.replace('* ', '');
  card_titles[i].innerHTML = updated_card;
}

// Home Page Sound


let supesuPn = document.querySelector('.sound-button audio');

function playPn() {
  supesuPn.play();
};


// Sticky JS

if (window.innerWidth < 750) {
//   console.log("mobile");
  let grabImgDiv = document.querySelector('.product__media-wrapper').clientHeight;
  let calcAtcY = grabImgDiv + 300;
//   console.log(calcAtcY);
  let stickyDiv = document.querySelector('#stickyDiv');

  let stickyAppear = function() {
    let atcY = window.scrollY;
    if (atcY >= calcAtcY) {
      stickyDiv.className = "atc-sticky sticky-show";
    } else {
      stickyDiv.className = "sticky-hide";
    }
  };
  window.addEventListener("scroll", stickyAppear);
}
else {
	stickyDiv.className = "sticky-hide";
}


// PREORDER / BACKORDER AND INVENTORY CODE

// List of SKUs - Take out any SKUs that we don't want to show as Buy in Advance
// const preorderArray = [43408863428823, 43408885579991, 43408885612759, 43408885645527, 43408885678295, 43408885711063, 43408863461591 , 43408885743831, 43408885776599, 43408885809367, 43408885842135, 43408885874903, 43411718734039, 43411588546775, 43411588579543, 43411588612311, 43411588645079, 43411588677847, 43411718832343, 43411589103831, 43411589136599, 43411589169367, 43411589202135, 43411589234903, 43411897712855, 43411862618327, 43411862651095, 43411862683863, 43411862716631, 43411862749399, 43411897811159, 43411863109847, 43411863142615, 43411863175383, 43411863208151, 43411863240919, 43411979174103, 43411979206871, 43411979239639, 43411979272407, 43411979305175, 43411979337943, 43411980058839, 43411980091607, 43411980157143, 43411980189911, 43411980288215, 43411980320983, 43412033732823, 43412033765591, 43412033798359, 43412033831127, 43412033863895, 43412033896663, 43412034322647, 43412034355415, 43412034388183, 43412034420951, 43412034453719, 43412034486487, 43411994247383, 43411994280151, 43411994312919, 43411994345687, 43411994378455, 43411994411223, 43411996803287 , 43411996836055, 43411996868823, 43411996901591, 43411996934359, 43411996967127, 43411994837207, 43411994869975, 43411994902743, 43411994935511, 43411994968279, 43411995001047, 43411997393111 , 43411997425879, 43411997458647, 43411997491415, 43411997524183, 43411997556951];


// Finds location of variant ID
let variantInput = document.querySelector(".product-form > form > input[name='id']");

// Pulls variant ID from location
let variantID = parseInt(variantInput.getAttribute("value"));

// First Conditional: If the current variant ID is in the list above, then change text to Buy in Advance
if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] == 0) {
console.log("first includes");
let preorderText = document.querySelector(".product-form__submit > span");
preorderText.innerHTML = preorderText.innerHTML.replace("Add to cart", "Buy in Advance");
};

// Selects an item that changes when a new variant is selected
let variantChange = document.querySelector(".product-form__submit");

// Mutation Observer function requirement
let options = {
    attributes: true
  };

// Mutation Observer function requirement
let mutObserver = new MutationObserver(preOrderScript);


// First Inventory Text upon First Page Load
 if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] == 0) {
 // No Stock - "If stock is zero"
 document.querySelector(".p-stock-out").style.display = "inline";
 }
 else if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] < 15) {
 // Low Stock - "If stock is less than 15"
 document.querySelector(".p-stock-low").style.display = "inline";
 }
 else if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] > 14) {
 // Available Stock - "If stock is less than 14"
 document.querySelector(".p-stock-av").style.display = "inline";
 }


// Function to activate when a mutation is observed
function preOrderScript () {

// Find location of variant ID again for newly selected variant
let variantInput = document.querySelector(".product-form > form > input[name='id']");
// Pull variant ID from location
let variantID = parseInt(variantInput.getAttribute("value"));

// Conditional: If variantID exists in variant list then change text to preorder
if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] == 0) {
  console.log("second includes");
  let preorderText = document.querySelector(".product-form__submit > span");
  preorderText.innerHTML = preorderText.innerHTML.replace("Add to cart", "Buy in Advance");
  } 
  else {
  console.log("does not include")
// If variant ID does not match, changes the text back to Add to cart
  let preorderText = document.querySelector(".product-form__submit > span");
  preorderText.innerHTML = preorderText.innerHTML.replace("Buy in Advance", "Add to cart");
  }

// Updating Inventory Stock Text on Variant Change Click
 if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] == 0) {
 // No Stock - "If stock is zero"
 document.querySelector(".p-stock-out").style.display = "inline";
 document.querySelector(".p-stock-low").style.display = "none";
 document.querySelector(".p-stock-av").style.display = "none";
 }
 else if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] < 15) {
 // Low Stock - "If stock is less than 15"
 document.querySelector(".p-stock-out").style.display = "none";
 document.querySelector(".p-stock-low").style.display = "inline";
 document.querySelector(".p-stock-av").style.display = "none";
 }
 else if (variantStock.hasOwnProperty(variantID) && variantStock[variantID] > 14) {
 // Available Stock - "If stock is less than 14"
 document.querySelector(".p-stock-out").style.display = "none";
 document.querySelector(".p-stock-low").style.display = "none";
 document.querySelector(".p-stock-av").style.display = "inline";
 }
  
};
// Activates mutation observer function
mutObserver.observe(variantChange, options);




// let product_titles = document.querySelectorAll(".product__title");
// for (let i = 0; i < product_titles.length; i++) {
//   let updated_title = product_titles[i].innerText.replace("* ", "");
//   product_titles[i].innerHTML = updated_title;
//   console.log("Product Title Updated");
// }

// window.addEventListener('load', function () {
//   console.log("It's loaded!")
//   let card_titles2 = document.querySelectorAll(".card__heading, .product__title");
// 	for (let i = 0; i < card_titles2.length; i++) {
//   let updated_card2 = card_titles2[i].innerHTML.replace('* ', '');
//   card_titles2[i].innerHTML = updated_card2;
//     }
// })